'use client';

import { buttonVariants } from '@lulalife/design-system';
import Link from 'next/link';
import type { ReactNode } from 'react';

type AuthLinkProps = {
  /** Route to navigate to. Client-side, via Next `Link`. */
  href: string;
  children: ReactNode;
  'data-testid'?: string;
};

/**
 * A text link on a signed-out screen (Forgot Password, Back to Login): the DS `link` button,
 * drawn on a real anchor so it still navigates, can be opened in a new tab and keeps its
 * link role.
 *
 * The colour and underline carry `!` for the reason `SettingsLink` spells out: Bootstrap's
 * reboot styles a bare anchor from unlayered rules, and an unlayered rule beats the layered
 * DS utilities unless the DS one is important.
 */
export const AuthLink = ({ href, children, 'data-testid': dataTestId }: AuthLinkProps) => (
  <Link
    href={href}
    data-testid={dataTestId}
    className={`${buttonVariants({ variant: 'link' })} text-text-link! no-underline! hover:text-text-link-hover!`}
  >
    {children}
  </Link>
);

export default AuthLink;
